import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";
function Remittances() {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Remittances" breadcrumbItem="Remittances" />
          <h4>Remittances</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Remittances;
